import { CheckBotInferenceStatus } from '../digitalization-uploads';
import { CheckbotStatusEnum } from '../documents-uploads';

export const checkBotAcceptedStatuses = [
  CheckbotStatusEnum.ok,
  CheckbotStatusEnum.info,
];

export const checkBotAcceptedWithRemarksStatuses = [CheckbotStatusEnum.warning];

export const positiveCheckBotStatuses = [
  ...checkBotAcceptedStatuses,
  ...checkBotAcceptedWithRemarksStatuses,
  CheckbotStatusEnum.timedOut,
];

export const NON_DEFINITIVE_CHECK_BOT_INFERENCE_STATUSES = [
  CheckBotInferenceStatus.WAITING,
  CheckBotInferenceStatus.PENDING,
  CheckBotInferenceStatus.PROCESSING,
];
